import { RedirectState } from '@neo.tax/shared';

export const useSredPayrollExpensesRedirect = (): RedirectState =>
  // TODO: Add proper loading checks for SRED context when CA context is implemented
  // For now, return a simple redirect state
  ({
    isLoading: false,
  });
